import React from "react";
import { mapEdgesToNodes } from "../../../lib/helpers";
import { graphql, useStaticQuery } from "gatsby";
import { ImageBuilder } from "../../global/image-builder";
import { pageDocPath } from "../../../../helpers";

const AVATAR_SIZE = 32;

const query = graphql`
  query StoryAvatarsQuery {
    docs: allSanityStory(
      sort: { fields: [publishedAt], order: DESC }
      filter: {
        slug: { current: { ne: null } }
        status: { eq: "published" }
      }
      limit: 16
    ) {
      edges {
        node {
          _type
          slug { current }
          publishedAt
          company {
            _id
            mainImage {
              ...SanityImageSimple
            }
          }
          quote {
            authors {
              _key
              author {
                name
                title
                image {
                  ...SanityImage
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const StoryAvatars = () => {
  const data = useStaticQuery(query) || {};
  const allStories = mapEdgesToNodes(data.docs);

  const seenCompanies = new Set();
  const items = allStories
    .filter((story) => {
      if (!story.company?._id || seenCompanies.has(story.company._id)) return false;
      seenCompanies.add(story.company._id);
      return true;
    })
    .map((story) => ({
      path: pageDocPath(story),
      company: story.company,
      author: story.quote?.authors?.[0]?.author,
    }))
    .filter(({ author }) => author?.image);

  return items.length > 0 ? (
    <div className="flex flex-row items-center">
      {items.map(({ path, company, author }, i) => (
        <div
          key={i}
          className="relative group shrink-0 z-0 hover:z-10"
          style={{ marginLeft: i > 0 ? "-8px" : 0 }}
        >
          <a
            href={path}
            className="rounded-full border-2 border-white group-hover:border-green-emerald overflow-hidden block transform duration-200 scale-100 group-hover:scale-150"
          >
            <ImageBuilder
              image={author.image}
              alt={author.name}
              width={AVATAR_SIZE}
              height={AVATAR_SIZE}
              className="rounded-full block h-8 w-8 object-cover"
            />
          </a>
          <div className="absolute top-full pt-4 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none group-hover:pointer-events-auto z-50">
            <div className="bg-white border border-dark-10 rounded-xl shadow-lg p-3 pb-0 text-left whitespace-nowrap">
              <p className="font-medium text-sm leading-tight">{author.name}</p>
              {author.title && (
                <p className="text-xs text-dark-60 mt-0.5">{author.title}</p>
              )}
              {company?.mainImage && (
                <ImageBuilder
                  image={company.mainImage}
                  height={48}
                  style={{ maxHeight: "48px" }}
                  className="mt-1"
                />
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : null;
};
